import React from "react";
import { Link } from "react-router-dom";
import { BASE_URL } from "./utility";

export default function Footer() {
  const navLinks = [
    { name: "Home", href: "/" },
    { name: "Products", href: "/products" },
    { name: "Brochures", href: "/brochures" },
    { name: "About Us", href: "/about" },
    { name: "Contact", href: "/contact" },
  ];

  const socialLinks = [
    { name: "Facebook", href: "https://www.facebook.com/rainbowtouchindia/", icon: "facebook" },
    { name: "Gmail", href: "mailto:rainbowtouchindia@gmail.com", icon: "gmail" },
    { name: "Instagram", href: "https://www.instagram.com/", icon: "insta" },
    { name: "Twitter", href: "https://twitter.com/", icon: "twitter" },
  ];

  return (
    <footer className="rt-footer">
      <style>
        {`
          .rt-footer {
            position: relative;
            overflow: hidden;
            margin-top: 2rem;
            color: #f7fafc;
            background:
              linear-gradient(135deg, rgba(9, 18, 32, 0.98), rgba(31, 43, 64, 0.96)),
              #111827;
          }

          .rt-footer::before {
            content: "";
            position: absolute;
            inset: 0;
            pointer-events: none;
            background:
              linear-gradient(90deg, #e63946, #f9c74f, #43aa8b, #277da1);
            height: 5px;
          }

          .rt-footer__inner {
            width: min(1180px, calc(100% - 32px));
            margin: 0 auto;
            padding: 34px 0 22px;
          }

          .rt-footer__top {
            display: grid;
            grid-template-columns: minmax(240px, 1.25fr) minmax(180px, 0.75fr) minmax(260px, 1fr);
            gap: 28px;
            align-items: start;
          }

          .rt-footer__brand {
            display: flex;
            gap: 14px;
            align-items: flex-start;
          }

          .rt-footer__logo {
            width: 58px;
            height: 58px;
            border-radius: 8px;
            object-fit: contain;
            background: #ffffff;
            padding: 6px;
            box-shadow: 0 12px 28px rgba(0, 0, 0, 0.22);
          }

          .rt-footer__title {
            margin: 0;
            font-size: 1.35rem;
            font-weight: 700;
          }

          .rt-footer__text,
          .rt-footer__contact-text {
            margin: 8px 0 0;
            color: #cbd5e1;
            line-height: 1.65;
            font-size: 0.95rem;
          }

          .rt-footer__heading {
            margin: 0 0 12px;
            color: #ffffff;
            font-size: 0.85rem;
            font-weight: 700;
            letter-spacing: 0.08em;
            text-transform: uppercase;
          }

          .rt-footer__nav,
          .rt-footer__contact {
            display: flex;
            flex-direction: column;
            gap: 9px;
          }

          .rt-footer__link,
          .rt-footer__contact-link,
          .rt-footer__site-link {
            color: #dbeafe;
            text-decoration: none;
            transition: color 0.2s ease, transform 0.2s ease;
          }

          .rt-footer__link:hover,
          .rt-footer__contact-link:hover,
          .rt-footer__site-link:hover {
            color: #f9c74f;
          }

          .rt-footer__link:hover {
            transform: translateX(3px);
          }

          .rt-footer__social {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            margin-top: 18px;
          }

          .rt-footer__social-link {
            width: 42px;
            height: 42px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border: 1px solid rgba(255, 255, 255, 0.18);
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.08);
            transition: transform 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;
          }

          .rt-footer__social-link:hover {
            transform: translateY(-3px);
            background: rgba(255, 255, 255, 0.16);
            border-color: rgba(249, 199, 79, 0.72);
          }

          .rt-footer__social-icon {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            object-fit: cover;
          }

          .rt-footer__bottom {
            display: flex;
            justify-content: space-between;
            gap: 16px;
            margin-top: 28px;
            padding-top: 18px;
            border-top: 1px solid rgba(255, 255, 255, 0.14);
            color: #cbd5e1;
            font-size: 0.9rem;
          }

          @media (max-width: 860px) {
            .rt-footer__top {
              grid-template-columns: 1fr 1fr;
            }

            .rt-footer__brand {
              grid-column: 1 / -1;
            }
          }

          @media (max-width: 560px) {
            .rt-footer__inner {
              width: min(100% - 24px, 1180px);
              padding: 28px 0 18px;
            }

            .rt-footer__top {
              grid-template-columns: 1fr;
              gap: 24px;
            }

            .rt-footer__brand {
              flex-direction: column;
            }

            .rt-footer__bottom {
              flex-direction: column;
            }
          }
        `}
      </style>

      <div className="rt-footer__inner">
        <div className="rt-footer__top">
          <div className="rt-footer__brand">
            <img className="rt-footer__logo" src="/rbtlogo.png" alt="Rainbow Touch" />
            <div>
              <h2 className="rt-footer__title">Rainbow Touch</h2>
              <p className="rt-footer__text">
                Interior decor solutions for wallpapers, panels, flooring,
                louvers, ceilings, carpets, and more.
              </p>
              <div className="rt-footer__social" aria-label="Social media links">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    className="rt-footer__social-link"
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.name}
                  >
                    <img
                      className="rt-footer__social-icon"
                      src={BASE_URL + "download/social/" + social.icon}
                      alt=""
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>

          <nav aria-label="Footer navigation">
            <h3 className="rt-footer__heading">Explore</h3>
            <div className="rt-footer__nav">
              {navLinks.map((link) => (
                <Link key={link.href} className="rt-footer__link" to={link.href}>
                  {link.name}
                </Link>
              ))}
            </div>
          </nav>

          <div>
            <h3 className="rt-footer__heading">Contact</h3>
            <div className="rt-footer__contact">
              <a className="rt-footer__contact-link" href="tel:+919818428983">
                +91-9818428983
              </a>
              <a className="rt-footer__contact-link" href="mailto:rainbowtouchindia@gmail.com">
                rainbowtouchindia@gmail.com
              </a>
              <p className="rt-footer__contact-text">
                F-711, Lado Sarai, Golf Course Road, Near Mehrauli, Delhi - 110074
              </p>
            </div>
          </div>
        </div>

        <div className="rt-footer__bottom">
          <span>
            &copy; 2005 - {new Date().getFullYear()} Rainbow Touch. All rights reserved.
          </span>
          <span>
            <a
              className="rt-footer__site-link"
              href="http://www.rainbowtouchindia.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              rainbowtouchindia.com
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
